import gql from 'graphql-tag';

export const FileListQuery = gql`
  query fileList($where: FileListWhereInput) {
    fileList(where: $where) {
      id
      id_files
      id_template
      id_parent
      system
      internal_code
      filename
      filetype
      filesize
    }
  }
`;

export const FileByNameQuery = gql`
  query fileByName($where: FileByNameWhereInput) {
    fileByName(where: $where) {
      id
      id_files
      id_template
      id_parent
      system
      filename
      filetype
      filesize
      file_url
      file_description
      backup
      created
      creator
      vytv_poradce
    }
  }
`;
